import TrackBase from "@/Core/Track/TrackBase";

export default class TrackCommon2 extends TrackBase {

    /** 内购界面展示时 */
    // 1=破产时弹出
    // 2=回到大厅时弹出
    // 3=大厅内点击
    // 4=机台内点击
    static iapPageShow(type:number) {
        this.T513("iap_page_show",'',type+'');
    }

    /** 点击内购界面的购买按钮时 */
    static iapPageClick(type:number) {
        this.T513("iap_page_click",'',type+'');
    }

    /** 发放奖励时 */
    static iap_reward() {
        this.T513("iap_reward");
    }

    /** 获取到支付短码时
     * @param itemId 内购编号（商店和首充会上传多条）（新手礼包、特惠礼包、商城固定档位）
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static pay_channel_code_show(itemId: string, payType: string, orderId: string) {
        this.T513("pay_channel_code_show", undefined, itemId, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
        ]);
    }

    /** 支付方式选择弹窗展示时
     * @param itemId 内购编号（商店和首充会上传多条）（新手礼包、特惠礼包、商城固定档位）
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static pay_method_show(itemId: string, payType: string, orderId: string) {
        this.T513("pay_method_show", undefined, itemId, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
        ]);
    }

    /** 支付方式选择弹窗点击时
     * @param itemId 内购编号（商店和首充会上传多条）（新手礼包、特惠礼包、商城固定档位）
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static pay_method_click(attribution: number, itemId: string, payType: string, orderId: string) {
        this.T513("pay_method_click", attribution.toString(), itemId, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
        ]);
    }

    /** 支付方式选择弹窗取消充值时
     * @param itemId 内购编号（商店和首充会上传多条）（新手礼包、特惠礼包、商城固定档位）
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static pay_method_cancel_click(itemId: string, payType: string, orderId: string) {
        this.T513("pay_method_cancel_click", undefined, itemId, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
        ]);
    }

    /** 显示半屏页面时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static s_pay_inapp_sc(attribution: number, payType: string, orderId: string) {
        this.T513("s_pay_inapp_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }

    /** 点击半屏页面的渠道时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static c_pay_inapp_sc(attribution: number, payType: string, orderId: string) {
        this.T513("c_pay_inapp_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }

    /** H5界面内提交支付信息时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static sub_pay_h5_sc(attribution: number, payType: string, orderId: string) {
        this.T513("sub_pay_h5_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }

    /** H5用户充值失败时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static deposit_fail_h5_sc(attribution: number, payType: string, orderId: string) {
        this.T513("deposit_fail_h5_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }

    /** H5用户支付入口展示时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static s_pay_h5_sc(attribution: number, payType: string, orderId: string) {
        this.T513("s_pay_h5_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }

    /** H5界面内点击支付icon入口时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static c_pay_h5_sc(attribution: number, payType: string, orderId: string) {
        this.T513("c_pay_h5_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }

    /** H5用户充值成功时
     * @param attribution 支付渠道
     * @param payType 支付短码
     * @param orderId 父订单id
     * */
    static deposit_suc_h5_sc(attribution: number, payType: string, orderId: string) {
        this.T513("deposit_suc_h5_sc", attribution.toString(), payType, [
            ['pay_channel_code', payType]
            , ['order_id', orderId]
            , ['pay_type', payType]
        ]);
    }


}
